import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------




const ProductPage = lazy(() => import('src/sections/brand/view/product-details-view'));


export const productRoutes = [
    {
        path: 'product',
          element: (
              <AuthGuard>
                <DashboardLayout>
                  <Suspense fallback={<LoadingScreen />}>
                    <Outlet />
                  </Suspense>
                </DashboardLayout>
              </AuthGuard>
            ),
        children: [
          { path: ':id', element: <ProductPage /> },
        ],
      },
      
];
